module.exports = __webpack_public_path__ + "media/categories/4003-b106fca8.svg";